// Centralized color identity per Strategy type, plus the one shared primary
// action color. These are NOT new colors - every value here is pulled
// directly from what BuyerStrategyPropertyRows.jsx's STRATEGY_MINI_CARDS and
// TransactionStrategyDashboard.jsx's Seller card grid already used before
// this redesign (see git history), just centralized into one place instead
// of being redefined inline at each card's call site. This app has no CSS
// custom-property design-token system (confirmed: styles.css defines none),
// so a small shared JS config is the lowest-risk way to keep these
// consistent without a larger, out-of-scope token migration.

export const PRIMARY_BLUE = "#2185d0"; // Semantic UI's default blue - already the de facto "TransActioner blue" used for every primary button/link across the app.

export const STRATEGY_THEME = {
  pricing: {
    icon: "dollar",
    color: "#21ba45",
    bg: "#e9f9ee",
    label: "Pricing Strategy",
  },
  listingDescription: {
    icon: "pencil alternate",
    color: "#00b5ad",
    bg: "#e1f7f6",
    label: "Listing Description",
  },
  negotiation: {
    icon: "comment outline",
    color: "#6435c9",
    bg: "#f1ecfc",
    label: "Negotiations Strategy",
  },
  inspection: {
    icon: "home",
    color: "#f2711c",
    bg: "#fdf0e6",
    label: "Inspection Strategy",
  },
};

// Coming-soon / disabled visual treatment - muted, never implies the card is
// interactive. Matches the grey already used in the pre-redesign
// StrategyMiniCard's comingSoon branch.
export const MUTED = {
  color: "#999999",
  bg: "#f0f0f0",
};
